import emotion from 'emotion/dist/emotion.umd.min.js';

const { css } = emotion;

export const inputWrapper = css`
  display: flex;
  flex-direction: column;
  position: relative;

  &.focused {
    &::after {
      transform: scaleX(1);
      z-index: 2;
    }
    
    & > label {
      color: #00aaae;
    }
  }

  &.error {
    &::after {
      transform: scaleX(1);
      z-index: 2;
      background-color: rgb(229, 75, 75);
    }
    
    & > label {
      color: rgb(229, 75, 75);
    }
  }

  &::before, &::after {
    content: '';
    bottom: 0px;
    left: 0;
    position: absolute;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    height: 1px;
  }

  &::before {
    background-color: rgba(0, 0, 0, 0.3);
  }

  &::after {
    height: 2px;
    background-color: rgb(0, 170, 174);
    transform: scaleX(0);
  }
`;

export const inputLabel = css`
  font-size: 12px;
  line-height: 1.25;
  letter-spacing: normal;
  color: #708697;
`;

export const input = css`
  height: 32px;
  padding: 0;
  border: none;
  outline: none;
  font-size:16px;
  color: #0d294a;
`;

export const inputErrMsg = css`
  display: inline-block;
  color: #e54b4b;
  font-size: 12px;
  margin: 5px 0 18px;
`

